// NOTE: showOnFrontPage only allows role 'CORE' team members to be turn on /off on the front page.

const teamMembers = [
  {
    h: 'Ryan John King',
    s: 'Co-founder, CEO',
    p:
      'Entrepreneur with a background in urban economic development, architecture and blockchain technology.',
    role: 'CORE',
    img: { src: '/publicAssets/team/Ryan.jpg', alt: '' },
    social: {
      twitter: 'https://twitter.com/frothcity',
      github: ''
    },
    showOnFrontPage: true
  },
  {
    h: 'Kristoffer Josefsson',
    s: 'Co-founder, CTO',
    p:
      'Senior full-stack blockchain and smart contract developer. Early member of Consensys. Founding Member of BlockApps.',
    role: 'CORE',
    img: { src: '/publicAssets/team/Kristoffer.jpg', alt: '' },
    social: {
      twitter: 'https://twitter.com/kejace',
      github: 'https://github.com/kejace'
    },
    showOnFrontPage: true
  },
  {
    h: 'Katya Zavyalova',
    s: 'Co-founder, Creative Director',
    p:
      'Award winning architect and a leading industry voice recognized by the American Institute of Architects.',
    role: 'CORE',
    img: { src: '/publicAssets/team/Ekaterina-Zavyalova.jpg', alt: '' },
    social: {
      twitter: 'https://twitter.com/katya_zavyalova',
      github: ''
    },
    showOnFrontPage: true
  },
  //  {
  //    h: 'Arthur Röing Baer',
  //    s: 'Head of Growth',
  //    p:
  //      'Designer and researcher. Previously worked on blockchain-enabled infrastructure decentralization in logistics and mobility.',
  //    role: 'CORE',
  //    img: { src: '/publicAssets/team/Arthur.jpg', alt: '' },
  //    social: {
  //      twitter: 'https://twitter.com/ArthurRoingBaer',
  //      github: ''
  //    },
  //    showOnFrontPage: true
  //  },
  {
    h: 'Ilya Ostrovskiy',
    s: '​​​<wizard/> / Hacker-in-Charge',
    p:
      'Polyglot programmer and DevOps plumber. Former VM lead at BlockApps. Co-author of the PureScript Ethereum development tool Chanterelle.',
    role: 'CORE',
    img: { src: '/publicAssets/team/Ilya.png', alt: '' },
    social: {
      twitter: '',
      github: 'https://github.com/iostat'
    },
    showOnFrontPage: true
  },
  // {
  //   h: 'Irakli Safareli',
  //   s: 'Senior Software Engineer',
  //   p:
  //     'Front-end developer and functional programming specialist. Author and contributor of many open source PureScript libraries, including the functional Ethereum stack developed at FOAM. Co-author of the Haskell cosmos/tendermint SDK.',
  //   role: 'TEAM',
  //   img: { src: '/publicAssets/team/irakli.png', alt: '' },
  //   social: {
  //     twitter: 'https://twitter.com/safareli',
  //     github: 'https://github.com/safareli'
  //   }
  // },
  {
    h: 'Anjali Vijay Kumar',
    s: 'Senior Electrical Engineer',
    p:
      'Computer Hardware Engineer specializing in electronic product design and firmware development. Specifically interested in IoT based technologies.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Anjali.jpg', alt: '' },
    social: {
      linkedIn: 'https://www.linkedin.com/in/anjalivijaykumar'
    }
  },
  {
    h: 'Michael Goldenberg',
    s: 'Software Engineer',
    p:
      'Michael has a background at the intersections of philosophy, education, and computer science. He’s interested in networks and decentralization.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Michael.png', alt: '' },
    social: {
      twitter: '',
      github: 'https://github.com/mgoldenberg'
    }
  },
  {
    h: 'Carl Factora',
    s: 'Software Engineer',
    p:
      'Functional programmer with a background in programming language theory. Former lead architect at Droit Financial Technologies.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Carl.png', alt: '' },
    social: {
      github: 'https://github.com/IvantheTricourne'
    }
  },
  {
    h: 'Coleman Moore',
    s: 'Technical Project Manager',
    p:
      'Technical Project Manager with experience implementing difficult technology solutions. Former Big 4 management consultant focused on Supply Chain technology.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Coleman.png', alt: '' },
    social: {
      twitter: 'https://twitter.com/nameloceroom'
    }
  },
  {
    h: 'Matt Earl',
    s: 'Senior Rust Engineer',
    p:
      'Programmer with a background in robotic fleet coordination and control.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Matt-Earl.png', alt: '' },
    social: {
      github: 'https://github.com/mattearl'
    }
  },
  {
    h: 'Aadil Hashmi',
    s: 'Electrical Engineer',
    p:
      'Aadil has an educational background in Biomedical and Electrical Engineering. He’s interested in network design and communication systems.',
    role: 'TEAM',
    img: { src: '/publicAssets/team/Aadil.png', alt: '' },
    social: {
      linkedIn: 'https://www.linkedin.com/in/aadil-h-5733b0139/'
    }
  },
  // {
  //   h: 'Jessica Salomon',
  //   s: 'Community and Growth',
  //   p:
  //     'Community, Marketing and Business Strategist. Former Community and Business at MakerDAO.',
  //   role: 'TEAM',
  //   img: { src: '/publicAssets/team/Jessica.png', alt: '' },
  //   social: {
  //     linkedIn: 'https://www.linkedin.com/in/jessica-salomon-772a94a9/'
  //   }
  // },
  // {
  //   h: 'Andrej Dukalev',
  //   s: 'Strategic Business and Operations Manager',
  //   p:
  //     'Andrej is a business developer with a background in engineering, passionate about finding product market fit in order to grow value for everyone involved.',
  //   role: 'TEAM',
  //   img: { src: '/publicAssets/team/Andrej.png', alt: '' },
  //   social: {
  //     linkedIn: 'https://www.linkedin.com/in/dukalev/'
  //   }
  // },
  // {
  //   h: 'Daryl Lau Toh Kin',
  //   s: 'Community Administrator',
  //   p:
  //     'Community administrator, passionate about growing communities centered around decentralization.',
  //   role: 'TEAM',
  //   img: { src: '/publicAssets/team/daryl.jpg', alt: '' },
  //   social: {
  //     twitter: 'https://twitter.com/Daryllautk',
  //     github: ''
  //   }
  // },
  {
    h: 'Martin Allen',
    s: 'Senior Blockchain Engineer',
    p:
      'Functional programming specialist, author of purescript-web3. Formerly a senior engineer at BlockApps. Background in algebraic geometry.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/Martin.jpg', alt: '' },
    social: {
      twitter: '',
      github: 'https://github.com/martyall'
    },
    showOnFrontPage: true
  },
  {
    h: 'Édouard Urcades',
    s: 'Product Designer',
    p: 'Édouard is a designer interested in infrastructure.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/ed.jpg', alt: '' },
    social: {
      twitter: 'https://twitter.com/edouerd',
      github: ''
    }
  },
  {
    h: 'General Trademark',
    s: 'Product R&D',
    p:
      'General Trademark is product R&D studio run by Callil Capuozzo and Gavin Atkinson.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/GT.jpg', alt: '' },
    social: {
      twitter: '',
      github: ''
    }
  },
  {
    h: 'Anna Kopp',
    s: 'Full Stack Engineer',
    p:
      'Anna is a software developer. She likes using Haskell to make compile time guarantees about data and functions.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/Anna.jpg', alt: '' },
    social: {
      twitter: '',
      github: ''
    },
    showOnFrontPage: true
  },
  {
    h: 'Ben Weitzman',
    s: 'Full Stack Engineer',
    p:
      'Ben is a software engineer with a deep interest in implementation and application of lazy functional languages.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/Ben.png', alt: '' },
    social: {
      twitter: '',
      github: ''
    },
    showOnFrontPage: true
  },
  {
    h: 'Sam Hart',
    s: 'Scientist',
    p:
      'Researcher specializing in quantitative analysis and systems design. Background in computational genomics, biophysics, and publishing.',
    role: 'COLLABORATOR',
    img: { src: '/publicAssets/team/Sam_Hart.jpg', alt: '' },
    social: {
      twitter: '',
      github: ''
    }
  },
  // {
  //   h: 'Matt Vernon',
  //   s: 'Product Designer',
  //   p:
  //     'Sydney-based Product Designer currently focusing on bringing great design and user experiences to decentralized applications.',
  //   role: 'COLLABORATOR',
  //   img: { src: '/publicAssets/team/matt-vernon.jpg', alt: '' },
  //   social: {
  //     twitter: 'https://twitter.com/dApp_boi',
  //     github: ''
  //   },
  //   showOnFrontPage: true
  // },
  // {
  //   h: 'Enrico Zago',
  //   s: '3D Artist',
  //   p:
  //     'Vienna-based artist and designer. His work involves 3D objects in order to investigate the perception of the physical environment into its digital representations and deformations.',
  //   role: 'COLLABORATOR',
  //   img: { src: '/publicAssets/team/Enrico-Zago.jpg', alt: '' },
  //   social: {
  //     twitter: '',
  //     github: ''
  //   },
  //   showOnFrontPage: true
  // },
  {
    h: 'Rick Dudley',
    s: 'Blockchain Technical Consultant and Advisor ',
    p:
      'President of Vulcanize, a firm providing decentralized applications with blockchain technical guidance, project management, and code & security audits; & Blockchain Architect for Omega One.',
    role: 'ADVISOR',
    img: { src: '/publicAssets/team/Rick-Dudley.png', alt: '' },
    social: {
      twitter: 'https://twitter.com/AFDudley0',
      github: ''
    },
    showOnFrontPage: true
  },
  // {
  //   h: 'Alyssa Wright',
  //   s: 'OpenStreetMap Consultant and Advisor',
  //   p:
  //     'Geospatial technologist, strategist & entrepreneur focused on the intersection of open innovation, community, and collaboration. Started at beginning of OpenStreetMap, OpenGeo, Open Transport Partnership and Mapzen. She’s let you know when she’s arrived at the destination.',
  //   role: 'COLLABORATOR',
  //   img: { src: '/publicAssets/team/alyssa.jpg', alt: '' },
  //   social: {
  //     twitter: 'https://twitter.com/alyssapwright',
  //     github: ''
  //   },
  //   showOnFrontPage: true
  // },
  {
    h: 'Matt Liston',
    s: 'Special Advisor',
    p: 'Founding member and ambassador of Gnosis, Augur cofounder.',
    role: 'ADVISOR',
    img: { src: '/publicAssets/team/Matt-Liston.jpg', alt: '' },
    social: {
      twitter: 'https://twitter.com/malloc8',
      github: ''
    },
    showOnFrontPage: true
  }
  // {
  //   h: 'Rivers Plasketes',
  //   s: 'Administrative Specialist',
  //   p: 'Rivers is an artist and writer based in Brooklyn.',
  //   role: 'TEAM',
  //   img: { src: '/publicAssets/team/rivers.jpg', alt: '' },
  //   social: {
  //     twitter: '',
  //     github: ''
  //   }
  // }
]

export { teamMembers }



// WEBPACK FOOTER //
// ./src/content/teamMembers.js